"use client"

import styled from "@emotion/styled"
import ExpertsSwiper from "./ExpertsSwiper"
import SidebarForm from "./Form"
import HeroContent from "./HeroContent"
import MainContent from "./MainContent"
import PartnershipSection from "./PartnershipSection"
import Sidebar from "./Sidebar"

// Main container
const PageContainerDesktop = styled.div`
  display: none;
  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 100vh;
    background-color: #009919;
    display: flex;
    flex-direction: column;
  }
`

const PageContainerMobile = styled.div`
  background-color: #009919;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  ${(props) => props.theme.breakpoints.up("sm")} {
    display: none;
  }
`

const HeroImageContainer = styled.div`
  position: relative;
  height: 170px;
  background-size: cover;
  background-position: center;
  width: 100%;
`

export default function BGRebuild() {
  return (
    <>
      <PageContainerDesktop>
        <Sidebar />
        <MainContent />
      </PageContainerDesktop>
      <PageContainerMobile>
        <PartnershipSection />
        <HeroContent />
        <ExpertsSwiper />
        <SidebarForm />
        <HeroImageContainer>
          <video
            src="/videos/bgrebuild_video.webm"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
            // poster="/images/hero-bg-48769a.jpg"
          />
        </HeroImageContainer>
      </PageContainerMobile>
    </>
  )
}
